import React, { FC } from 'react';
import { useTheme } from '../../theme';
import ModalX from '../../BaseComponents/ModalX';
import { OwnStyles } from '../types';
import classNames from 'classnames';
import { ModalXProps } from '../../BaseComponents/ModalX/components/ModalX';

export interface Props extends ModalXProps {
	className?: string;
	classes?: ModalXProps['classes'] & OwnStyles;
}

const ModalFullscreen: FC<Props> = ({
	className,
	classes,
	ignoreClose,
	title,
	footer,
	children,
	scroll,
	isOpen,
	onClose,
	...props
}) => {
	const theme = useTheme('ModalFullscreen')?.ModalFullscreen || {};

	return (
		<ModalX
			isOpen={isOpen}
			onClose={onClose}
			ignoreClose={ignoreClose ?? true}
			scroll={scroll}
			classes={{
				...theme,
				root: classNames(theme.paper, classes?.root),
				paper: classNames(theme.paper, classes?.paper, { [theme.scrollBody]: scroll === 'body' }),
				top_wrapper: classNames(theme.top_wrapper, classes?.top_wrapper),
				dialog_container: classNames(theme.scrollBody, classes?.scrollBody),
				content: classes?.content
			}}
			title={title && <div className={classNames(theme.header, classes?.header)}>{title}</div>}
			footer={footer && <div className={classNames(theme.footer, classes?.footer)}>{footer}</div>}
			{...props}
			noPadding={true}
			size="fullscreen"
		>
			{children && (
				<div className={classNames(theme.content, className, { [theme.scrollPaper]: scroll === 'paper' })}>
					{children}
				</div>
			)}
		</ModalX>
	);
};

export default ModalFullscreen;
